import { ContextMenu, ContextMenuDeleteWithModelUsageItem, ContextMenuItem, Id, useHasPermission } from "@dgs/core";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { PermissionName } from "../../../shared/types/permission";
import { organizationalUnitService } from "../shared/api/organizationalUnitService";

interface Props {
	organizationalUnitId: Id;
	handleEdit: () => void;
	handleDelete: () => Promise<any>;
}

export const OrganizationalUnitListContextMenu: FC<Props> = ({ organizationalUnitId, handleEdit, handleDelete }) => {
	const { t } = useTranslation();

	const showUsageAction = useCallback(
		() => organizationalUnitService.usages(organizationalUnitId).then((r) => r.data.data),
		[organizationalUnitId],
	);

	const canUpdate = useHasPermission<PermissionName>(["organizationalUnits.update"]);
	const canDelete = useHasPermission<PermissionName>(["organizationalUnits.delete"]);

	return (
		<>
			<ContextMenu displayShortcutsAs="icon">
				{canUpdate && (
					<ContextMenuItem label={t("Edit")} action={handleEdit} title={t("Edit")} icon="edit" shortcut="primary" />
				)}
				{canDelete && (
					<ContextMenuDeleteWithModelUsageItem
						label={t("Delete")}
						title={t("Delete")}
						showUsageAction={showUsageAction}
						modelName={t("Organizational unit")}
						confirmationBody={t("Are you sure you want to delete this organizational unit?")}
						deleteAction={handleDelete}
						shortcut="danger"
					/>
				)}
			</ContextMenu>
		</>
	);
};
